import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

type RoundingCellProps = {
  value: number;
};

export const MonthlyValueCell = ({ value }: RoundingCellProps) => {
  const { t } = useTranslation();

  if (!value) return <Typography variant="body1">-</Typography>;

  return (
    <>
      <Typography
        variant="body1"
        sx={{
          display: 'inline',
        }}
      >
        {`${value}M `}
      </Typography>
      <Typography
        variant="body1"
        color="textSecondary"
        sx={{
          display: 'inline',
        }}
      >
        {t('Monthly')}
      </Typography>
    </>
  );
};
